import { getPublishTerms as getPublishTermsRequest } from './repository';
import { mapPublishTerms } from './utils';
import { IGetPublishTermsParams, TGetPublishTermsResult } from './types';

export async function getPublishTerms(params: IGetPublishTermsParams): Promise<TGetPublishTermsResult> {
  const publishTermsResponse = await getPublishTermsRequest(params);

  return mapPublishTerms(publishTermsResponse);
}
